// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
    //suggestionMode: 'test',
    //suggestionStyle: 'style2',
    //suggestionStyle2MainContainerSelector: '#shopify-section-header',
    suggestionMobileStyle: 'style2',
    suggestionStyle: 'style2',
    suggestionStyle2MainContainerSelector: '#Search .Search__Inner', 
  }
};

//Set theme search mode to product only
window.theme.searchMode = 'product';

(function () {
  BoostPFS.inject(this);

  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function () {
    var suggestionElement = this.$uiMenuElement;
    var searchElement = this.$element;
    var searchBoxId = this.id;
  };

  SearchInput.prototype.beforeBindEvents = function (id) {
    var id = this.id;
    if (id == Class.searchBox + '-0') {
      this.$element = removeThemeSearchEvent();
      this.instantSearchResult.$searchInputElement = this.$element;
    }
    recallThemeOnPageShowEvent();

    if (Utils.InstantSearch.isFullWidthMobile()) {
      jQ(id).removeAttr('autofocus');
      if (jQ(id).is(':focus')) {
        jQ(id).blur();
      }
    }
  };

  SearchInput.prototype.afterBindEvents = function() {
    // Fix cannot redirect to search page when pressing enter
    jQ('.boost-pfs-search-box').on('keypress', function(event) {	
      if (event.keyCode == 13) {	
        jQ(this).parents('form').submit();	
      }	
    })
  }

  function removeThemeSearchEvent() {
    // Remove all events
    if (jQ('[name="q"]').length > 0) {
      var cloneSearchBar = jQ('[name="q"]').first().clone();
      jQ(cloneSearchBar).removeClass('Form__Input').addClass('Search__Input Heading');
      jQ('[name="q"]').first().empty().append(cloneSearchBar);
      if (jQ('#Search').length > 0) {
        if (jQ('#Search').hasClass('Modal--fullScreen')) {
          jQ('#Search').attr("style", "height: 0px !important");
        }
        jQ('#Search .Search__Results').attr("style", "display: none !important");
      }

      // Rebuild click search icon event
      if (jQ('[data-action="toggle-search"]').length > 0) {
        jQ('[data-action="toggle-search"]').on('click', function () {
          setTimeout(function () {
            jQ('[name="q"]').first().focus();
          }, 500);
           
        })
      }
    }
    // disable page transition
    if (window.theme && window.theme.showPageTransition) {
      window.theme.showPageTransition = false;
    }
    return jQ('[name="q"]').first();
  }

  function recallThemeOnPageShowEvent() {
    // disable page transition
    var pageTransition = document.querySelector('.PageTransition');
    if (pageTransition) {
      pageTransition.style.visibility = 'visible';
      pageTransition.style.opacity = '0';
    }
    // refresh cart
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    }));
  }
  
  
  // Change HTML Markup for Mobile
 // if(Utils.isMobile()) {
      InstantSearchResultItemProduct.prototype.getTemplate = function(tempType) {
		var customImageUrl = this.imageUrl
        	
          switch (tempType) {
              case InstantSearchResultItemProduct.tempType.IMAGE:
                  return `
                      <div class="{{class.searchSuggestion}}-left">
<img tabindex="-1" src="${customImageUrl.replace('200x', '700x')}" alt="{{escapedTitle}}">
                      </div>
                  `.trim();
              case InstantSearchResultItemProduct.tempType.SKU:
                  return `
                      <p class="{{class.searchSuggestion}}-product-sku">SKU: {{sku}}</p>
                  `.trim();
              case InstantSearchResultItemProduct.tempType.VENDOR:
                  return `
                      <p class="{{class.searchSuggestion}}-product-vendor">{{vendor}}</p>
                  `.trim();
              case InstantSearchResultItemProduct.tempType.PRICE:
                  return `
                      <p class="{{class.searchSuggestion}}-product-price">
                          <span class="{{class.searchSuggestion}}-product-regular-price">{{regularPrice}}</span>
                      </p>
                  `.trim();
              case InstantSearchResultItemProduct.tempType.PRICE_SALE:
                  return `
                      <p class="{{class.searchSuggestion}}-product-price">
                          <s>{{compareAtPrice}}</s>&nbsp;
                          <span class="{{class.searchSuggestion}}-product-sale-price">{{regularPrice}}</span>
                      </p>
                  `.trim();
              default:
                  return `
                      <li class="Carousel__Cell {{class.searchSuggestionItem}} {{class.searchSuggestionItem}}-product {{class.searchUiAutocompleteItem}}" aria-label="{{escapedBlockType}}: {{escapedTitle}}" data-id="{{id}}" role="option">
                          <a tabindex="-1" href="{{url}}" {{newTabAttribute}}>
                              {{itemProductImage}}
                              <div class="{{class.searchSuggestion}}-right">
                                  <p class="{{class.searchSuggestion}}-product-title">{{title}}</p>
                                  {{itemProductSku}}
                                  {{itemProductVendor}}
                                  {{itemProductPrice}}
                                  {{itemProductLabel}}
                              </div>
                          </a>
                      </li>
                  `.trim();
          }
      }
      // higher parent
      InstantSearchResultBlock.prototype.getTemplate = function (tempType) {
          switch (tempType) {
              case 'dym':
                  return `
                      <li class="{{class.searchSuggestionItem}} {{class.searchSuggestion}}-dym" aria-label="Did you mean">{{dymContent}}</li>
                  `.trim();
              default:
                  return `
                      <div class="{{class.searchSuggestionGroup}}" data-group="{{type}}" aria-label="{{label}}">
                          <ul>
                              <li class="{{class.searchSuggestionHeader}}-{{type}} {{class.searchSuggestionHeader}} aa" aria-label="{{label}}">{{label}}</li>
                              <div class="search_div_item ProductList ProductList--carousel Carousel"></div>
                                {{resultItems}}
                          </ul>
                      </div>
                  `.trim();
          }
      }
  InstantSearchResultItemProduct.prototype.compileTemplate = function() {
		if (this.isShow) {
			var searchTerm = Utils.stripHtml(Globals.currentTerm);
			// Product image
			var imageHTML = '';
			if (Settings.getSettingValue('search.showSuggestionProductImage') && this.imageUrl.length) {
				imageHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.IMAGE);
				imageHTML = imageHTML.replace(/{{imageUrl}}/g, this.imageUrl);
			}
			// Product title
			var productTitle = this.customizeProductTitle();
			productTitle = this._highlightSuggestionResult(productTitle, searchTerm);
			// SKU
			var skuHTML = '';
			if (Settings.getSettingValue('search.showSuggestionProductSku') && this.sku.length) {
				skuHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.SKU);
				skuHTML = skuHTML.replace(/{{sku}}/g, this.sku);
			}
			// Vendor
			var vendorHTML = '';
			if (Settings.getSettingValue('search.showSuggestionProductVendor') && this.vendor.length) {
				vendorHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.VENDOR);
				vendorHTML = vendorHTML.replace(/{{vendor}}/g, this.vendor);
			}
			// Price
			var priceHTML = this.compileSuggestionProductPrice();
			// Open the result item in new tab when selected
			var newTabAttr = Settings.getSettingValue('search.openProductNewTab') ? 'target="_blank"' : '';
            var customData = this.data
            var customvariant = customData.variants.filter(function(e) {
              return e.inventory_quantity > 0 && e.inventory_management == 'shopify'
            });
            var labelHTML = '';
            if((customData.tags.includes("RTS") || customData.tags.includes("pfs:label-Ready to Ship")) && typeof customvariant[0] !== 'undefined'){
              labelHTML = '<p class="tk-roc-grotesk RTS">READY TO SHIP</p>';
            }              
			return this.getTemplate()
				.replace(/{{id}}/g, this.id)
				.replace(/{{escapedBlockType}}/g, Utils.stripHtml(this.parent.type))
				.replace(/{{url}}/g, this.url)
				.replace(/{{newTabAttribute}}/g, newTabAttr)
				.replace(/{{itemProductImage}}/g, imageHTML)
				.replace(/{{title}}/g, productTitle)
				.replace(/{{escapedTitle}}/g, Utils.stripHtml(productTitle))
				.replace(/{{itemProductSku}}/g, skuHTML)
				.replace(/{{itemProductVendor}}/g, vendorHTML)
				.replace(/{{itemProductPrice}}/, priceHTML)
				.replace(/{{class.searchSuggestion}}/g, Class.searchSuggestion)
				.replace(/{{class.searchSuggestionItem}}/g, Class.searchSuggestionItem)
                .replace(/{{itemProductLabel}}/g, labelHTML)
				.replace(/{{class.searchUiAutocompleteItem}}/g, Class.searchUiAutocompleteItem);
		} else {
			return '';
		}
	}
      InstantSearchResultBlock.prototype.render = function () {
		this.$element = jQ(this.compileTemplate());
		// Add Did you mean block in product block
		if (this.type && this.type === InstantSearchEnum.ResultType.PRODUCTS) {
			this.blockDym.render();
			this.blockDym.bindEvents();
			if (this.blockDym.$element) {
				this.$element = jQ(this.compileTemplate());
				this.$element.find(' ul').append(this.blockDym.$element);
			}
		}

		this.children.forEach((child) => {
			if (child.$element) {
				//this.$element.find(' ul').append(child.$element);
              this.$element.find('.search_div_item').append(child.$element);
			}
		});
	}
 // }
  
  // Trigger click when icon search clicked
  jQ('[aria-label="Search"], [data-action="toggle-search"]').on('click', function (){
    setTimeout(function(){
      if(jQ('.PageOverlay').hasClass('is-visible')){
        jQ('.Search__Input.Heading.boost-pfs-search-box').click();
        
        
      }
    }, 200)
  })
  
})();
